export default __webpack_public_path__ + "static/media/hdpe-regrinds.4a54f675.jpg";